module.exports = __webpack_public_path__ + "media/img/logos/2024/absolvierendenhut-f856271096783be6da91b9b9e020711d.svg";